import { render, staticRenderFns } from "./TimeFormat.vue?vue&type=template&id=01994daa&scoped=true&"
import script from "./TimeFormat.vue?vue&type=script&lang=js&"
export * from "./TimeFormat.vue?vue&type=script&lang=js&"
import style0 from "./TimeFormat.vue?vue&type=style&index=0&id=01994daa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01994daa",
  null
  
)

export default component.exports